// resources/js/Pages/Formula/questions/SimpleModeSidebar.js

import React from 'react';
import { Form, Card } from 'react-bootstrap';

export default function SimpleModeSidebar({ contextSettings, onContextChange }) {
  return (
    <Card className="h-100">
      <Card.Header>
        <h6 className="mb-0">📄 Context Options</h6>
        <small className="text-muted">Choose background info for the AI</small>
      </Card.Header>
      <Card.Body>
        <Form.Group className="mb-3">
          <Form.Label className="fw-medium">Include Script Context</Form.Label>
          <Form.Select
            value={contextSettings.context_inclusion || 'synopsis'}
            onChange={e => onContextChange('context_inclusion', e.target.value)}
          >
            <option value="synopsis">Include Synopsis Only</option>
            <option value="scene_summary">Include Scene-by-Scene Summary</option>
            <option value="full_text">Include Full Script Text</option>
          </Form.Select>
          <Form.Text className="text-muted">Controls how much script info is provided.</Form.Text>
        </Form.Group>
        
        <Form.Group className="mb-3">
          <Form.Label className="fw-medium">Additional Context</Form.Label>
          <Form.Check
            type="checkbox"
            label="Include Character Descriptions"
            checked={!!contextSettings.include_character_descriptions}
            onChange={e => onContextChange('include_character_descriptions', e.target.checked)}
          />
          <Form.Text className="text-muted">Adds character profiles and arcs.</Form.Text>
        </Form.Group>
            <small class="form-text text-muted">
        Costs vary based on context type. 
            Using <strong>synopsis/scene summary</strong> context (lower cost).
    </small>

      </Card.Body>
    </Card>
  );
}
